import { IconType } from 'react-icons';
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaSnapchat,
  FaTumblr,
  FaTwitch,
  FaYoutube,
  FaPinterest,
  FaEnvelope,
} from 'react-icons/fa';

import { Facebook, Instagram, Tiktok, Snapchat, Twitter, TwitterMonochrome, Threads, ThreadsMonochrome, Tumblr, Twitch, Youtube, Pinterest, Email } from './../../icons';

export const iconMap = {
  monochrome_facebook: FaFacebook,
  monochrome_snapchat: FaSnapchat,
  monochrome_threads: ThreadsMonochrome,
  monochrome_twitter: TwitterMonochrome,
  monochrome_tiktok: FaTiktok,
  monochrome_youtube: FaYoutube,
  monochrome_twitch: FaTwitch,
  monochrome_tumblr: FaTumblr,
  monochrome_instagram: FaInstagram,
  monochrome_pinterest: FaPinterest,
  monochrome_email: FaEnvelope,
  facebook: Facebook,
  snapchat: Snapchat,
  threads: Threads,
  twitter: Twitter,
  tiktok: Tiktok,
  youtube: Youtube,
  twitch: Twitch,
  tumblr: Tumblr,
  instagram: Instagram,
  pinterest: Pinterest,
  email: Email,
} as Record<string, IconType>;
